export const itpFuncs = ["R", "I", "V", "W", "H"];

export const manufacturingTabs = [
  "Production Impact test (Production Charpy Test) shell side",
  "PMI of SS weld consumables",
  "PMI of Raw Materials (SS materials)",
  '"Dimensional Inspection and Fit-Up Check of Shell assembly',
  "Check: ID/OD, Out of roundness",
  "Dimensional Check including Nozzle projection, orientation and elevation",
  "Dimensional Check of Glycol Coil & Baffle assembly (Internals)",
  "Random verification of Welding (as required by WPS/PQR)",
  "Radiography RT-1",
  'Full UT on Cat ""D"" Joints(Before Reinforcing pads welding)',
  '100% MPI of Cat ""D"" welds (External surfaces)(Before and after Reinforcing pads welding)',
  "100% MPI of L/S welds, C/S Welds (External Surfaces)",
  "100% MPI of Temps, Arc-Strikes & attachment welds (External Surfaces)",
  '100% WFMT of Cat "D" welds (Internal Surfaces)',
  "100% WFMT of L/S welds, C/S Welds (Internal Surfaces)",
  "100% WFMT of Temps, Arc-Strikes & attachment welds (Internal Surfaces)",
  "Welding Repair as required",
  "Nozzle Flange Face Surface finish and gasket face inspeciton",
  "Final Visual Inspection - Shell side Internals",
  "Final Visual Inspection - Shell side Externals",
];

export const preFab = [
  "Pre-Fabrication Meeting",
  "Customer Specs Reviewed & accepted",
  "IFC drawings and design calculations to shop",
  "Registered Drawings to Shop",
  "AI Hold Points Established",
  "Customer Hold Points Established",
  "WPS/PQR Approval",
  "Welder Qualification Records",
  "NDE Procedures Approval",
  "NDE Personnel Qualification",
  "Material Teast Reports (MTR)",
  "Material Identification/examination + Heat # Check, record and tracability",
  "Receiving Inspection all Dished Ends/Heads",
  "Receiving and Dimensional Inspection of Shell",
];

export const pwht = [
  "Post Weld Heat Treatment (PWHT) (Complete equipment)",
  "Radiography RT-1 (After PWHT)",
  `Full UT on Cat "D" Joints(After PWHT)`,
  `100% MPI of Cat "D" welds (External surfaces)(After PWHT)`,
  "100% MPI of L/S welds, C/S Welds (External Surfaces)  (After PWHT)",
  "100% MPI of Temps, Arc-Strikes & attachment welds (External Surfaces)  (After PWHT)",
  '100% WFMT of Cat "D" welds (Internal Surfaces)  (After PWHT)',
  "100% WFMT of L/S welds, C/S Welds (Internal Surfaces)  (After PWHT)",
  "100% WFMT of Temps, Arc-Strikes & attachment welds (Internal Surfaces)  (After PWHT)",
  "Hardness Test after PWHT  on process side whereever accessible",
  "Nozzle Flange Face Surface finish check",
  "Closure of  any open NCR",
  "Final Visual Inspection - After PWHT",
  "Final Visual Inspection - After PWHT",
];

export const hydrostaticTest = [
  "Potable water Chloride content report (Water Quality Certificate)",
  "Hydrotest",
  "Drain and Dry",
];

export const finalPreparation = [
  "Baseline UT (Thickness survey)",
  "TSA coating on External Surfaces (Separate ITP)",
  "Electrical Heat Tracing (EHT) (Separate ITP)",
  "Electrical Heat Tracing (EHT) Reports",
  "Insulation & Jacketing (Separate ITP)",
  "UT Inspection Port",
  "Stencling on Top of Insulation Jacketing",
  "Nameplate Complete   ",
  "Manufacturers Data Report Complete",
  "Nozzle Flange Gasket Face condition check & Protection for Shipping",
  "Preparation for Shipment/Ship Loose Items Check ",
  "Final Inspection Release",
  "Final Shipping Release",
  "Shipping Loadout and Shipping photo",
  "Docs with Shipment",
];

export const ndeProcedures = [
  "Radiography Testing (RT) Procedure",
  "Ultrasonic Testing (UT) General Weld Procedure",
  "Magnetic Particle Testing (MT) Procedure",
  "Hardness Testing Procedure for Portable Equipment",
  "Visual Examination Procedure",
  "PMI Procedure",
];

export const manufacturingProcedures = [
  "Post Weld Heat Treatment (PWHT) Procedure",
  "Project Specification",
  "Hydrostatic Testing Procedure",
  "Blasting & Painting Procedure",
  "Storage & Preservation Procedure",
  "Weld Repair Procedure",
];

export const Notes = [
  "Refer to CDT Drawing Number ",

  "Record to be maintained in QC Job file (EI / Sub-Vendor) for incorporation into MRB",

  "Acceptance criteria is as per Codes / Standards / Client Specfications & / or as per EI Drg.: ",

  "NDE Tech Qualifications = Level-II (CGSB or ASNT).",

  "Refer to project specific approved WPS/PQR, NDE Procedures as applicable.",

  `Tolerances: As per CDT "000004-STANDARD FABRICATION TOLERANCES REV.2" OR as per IFC Drawings, whichever is stringent.`,

  "Receiving of all raw materials, parts, partially/fully fabricated components in accordance with CDT Quality Control Manual.",

  "If Black White contrast MPI is to be performed, the paint shall be removed by buffing after MPI testing.",

  "Docs with Shipment to Client : Inspection Release, Signed ITP, MDR, Packing List, Bill of Lading (BOL), Storage and Preservation procedure.MSDS's: Rust Preventative",

  "* Customer/Vendor/AI/TPI (as applicable) to mark their intervention points (R/I/V/W/H) at their respective column.",
];

export const definitions = [
  {
    key: "R",
    content:
      "Documentation Review is defined as an inspection process in which the Purchasers Inspector checks documents for accuracy, relationship to object or items to which they pertain, and conformance with Specifications, Codes or Standards. The reviews are performed during standard inprogress inspection visits. The review, initialing and dating of the documents by the Purchasers Inspector does not constitute acceptance.",
  },
  {
    key: "I",
    content:
      "Inspect is defined as survCDTlance activities during standard in-progress inspection visits, including detailed observations and measurements, verifying compliance with the Specifications and Purchase Order requirements.",
  },
  {
    key: "V",
    content:
      "Verification Points are defined as important steps, processes or tests in the Seller’s manufacturing cycle that the Purchasers Inspector will monitor during standard in-progress inspection visits. Results of these observations are required to be included in the inspection report for the specific visit when the observation was made.",
  },
  {
    key: "W",
    content:
      "Witness Points are defined as critical steps, processes or tests in the Seller’s manufacturing cycle that the Purchasers Inspector will witness. If the Purchasers Inspector does not attend the witness point, the Seller can only proceed with the work past the witness point when the Purchasers Inspector waives his right to attend. The Seller shall give the Purchasers Inspector Five (5) working days advance notice (OR AS AGREED) of the activity each time the activity is to be performed so that it can be witnessed.",
  },
  {
    key: "H",
    content:
      "Hold Points are defined to be the same as Witness Points except the Seller may not proceed with the work beyond the hold point without the Purchasers Inspector in attendance to witness the activity. The Seller shall give the Purchasers Inspector Five (5) working days advance notice (OR AS AGREED) of the activity each time the activity is to be performed, so that it can be witnessed.",
  },
];

export const optionsByType = {
  "Documents Review and Approval": {
    "INSPECTION/TEST ACTIVITY": [
      "Inspection and Test Plan",
      "Drawings Review and approval",
      "ABSA Design Registration for Pressure Equipment and Pressure Piping",
      "Welding Procedures Specifications & Procedure Qualification Records",
      "NDE Procedures",
      "PWHT",
      "Pressure Test Procedure",
      "Surface Preparation and Coating Procedure",
      "FAT/ Performance Test Procedure",
      "Pre-Inspection Meeting",
    ],
    "CONTROLLING DOCUMENT": [
      "Approved ITP",
      "IFC Drawing",
      "WPS/ PQR - IFC Drawings",
      "Procedure",
      "Meeting",
    ],
    "Res. Party/ Location": ["SHOP", "TBD", "Sub-contract"],
    "ACCEPTANCE CRITERIA": [
      "Client Approved ITP",
      "IFC Drawings",
      "CSA B51",
      "ASME IX/CSA W59",
      "Client Spec",
      "ASME B31.3/VIII-1",
      "PO/SOW",
    ],
    "RECORDING DOCUMENT": [
      "ITP Initials",
      "IFC Drawings",
      "ABSA Declaration Letter",
      "WPS/PQR",
      "NDE Reports",
      "PWHT Reports",
      "Test Reports",
      "MOM",
    ],
    shopType: ["H", "W", "R", "V"],
    clientType: ["H", "W", "R", "V"],
  },
  "Steel Structure Fabrication (Separate ITP will be provided if sub-contracted)":
    {
      "INSPECTION/TEST ACTIVITY": [
        "Verify IFC Drawings Approved",
        "Approved WPS Used For Fabrication",
        "Verify Welder Qualifications",
        "Lifting Lugs MTR Review",
        "Weld Prep & Fit Up",
        "Fabricator to ensure back gouged root pass is clean",
        "100% Visual Weld Inspections",
        "MT Lifting Lugs (100%) ",
        "Sump Leak Test including drain pipe",
        "Surface Prep and Coating ",
        "Underskid insulation",
        "Final Inspection",
      ],
      "CONTROLLING DOCUMENT": [
        "Fabrication drawings ",
        "WPS/WPDS/IFC",
        " Welders Log/Certification",
        "SOW/PO/MTR",
        "Weld Procedure, IFC Drawings",
        "CSA W59",
        "MPI Procedure/Technician Qualification",
        "IFC Drawing ,Surface Prep and Coating Procedure ",
        "Insulation Procedure ",
        "CSA W59/IFC Drawings",
      ],
      "Res. Party/ Location": ["SHOP", "TBD", "Sub-contract"],
      "ACCEPTANCE CRITERIA": [
        "IFC Drawing",
        "CSA W59 and W47.1",
        "IFC Drawings ,CSA W59",
        "Weld Procedures",
        "CSA W59, IFC Drawing",
        "CSA W59",
        "IFC Drawings, CSA W59",
        "Surface Prep and Coating Specification",
        "PO/Client Spec",
      ],
      "RECORDING DOCUMENT": [
        "ITP Initials",
        "ITP Initials/Initials  MTR",
        "MT Reports",
      ],
      shopType: ["H", "W", "R", "V"],
      clientType: ["H", "W", "R", "V"],
    },
  "ASME Pressure Equipment Fabrication (Separate ITP will be provided if sub-contracted)":
    {
      "INSPECTION/TEST ACTIVITY": [
        "Review Approved WPS to be used",
        "Review Welder Qualifications",
        "Review IFC Drawings",
        "CRN Verification",
        "Material Verification and MTR Review",
        "Weld Joint Prep & Fit Up",
        "Dimensions and Orientations checked",
        "Welds visual inspection ",
        "Post Weld Heat Treatment  ",
        "NDE (RT,MT, UT, PT, etc.) as applicable",
        "Hydrostatic Test",
        "Surface Prep and Coating",
        "Insulation/heat tracing",
        "ASME Data Report sign off",
        "Name Plate Stamping and Installation",
        "Final Internal Cleanliness & Final Inspection",
      ],
      "CONTROLLING DOCUMENT": [
        "Fabrication drawings ",
        "WPS/WPDS/IFC",
        " Welders Log/Certification",
        "SOW/PO/MTR",
        "Weld Procedure, IFC Drawings",
        "CSA W59",
        "MPI Procedure/Technician Qualification",
        "IFC Drawing ,Surface Prep and Coating Procedure ",
        "Insulation Procedure ",
        "CSA W59/IFC Drawings",
      ],
      "Res. Party/ Location": ["SHOP", "TBD", "Sub-contract"],
      "ACCEPTANCE CRITERIA": [
        "ASME VIII-1/ ASME IX",
        "QC Manual ",
        "CSA B51",
        "ASME VIII-1, ASME II",
        "ASME Sec. VIII-1",
        "Surface Prep and Coating Specification",
        "ASME Sec. VIII-1",
        "PO",
      ],
      "RECORDING DOCUMENT": [
        "ITP Initials",
        "ITP Initials/ Welders Log",
        "Declaration Letter",
        "ITP/MTR Initials",
        "ITP Initials/Travel Sheet ",
        "ITP Initials, PWHT report",
        "ITP Initials/ NDE Reports",
        "ITP Initials, Hydrotest Report",
        "U Form",
        "ITP Initials/Travel Sheet ",
      ],
      shopType: ["H", "W", "R", "V"],
      clientType: ["H", "W", "R", "V"],
    },
  "Piping Fabrication": {
    "INSPECTION/TEST ACTIVITY": [
      "Review Approved ISO Spool drawings",
      "Verify that WPS to be used are Approved",
      "Verfy Welder Qualifications",
      "Material Verification & MTR review",
      "Weld Joint Prep & Fit Up",
      "Welds visual inspection ",
      "NDE (RT,MT, UT, PT, etc.) as applicable",
      "Post Weld Heat Treatment",
      "Verify Pressure Test Gauges",
      "Pressure Test",
      "Surface Prep and Coating",
      "Insulation/heat tracing",
      "Pipe Cleanliness",
      "Construction Data Report Sign off",
    ],
    "CONTROLLING DOCUMENT": [
      "IFC Spool drawings",
      "Weld Procedures",
      "Welder Certificates/Welder Log",
      "SOW/MTR",
      "IFC Drawings",
      "IFC Drawings/ NDE Procedure",
      "ASME B31.3, IFC Drawings",
      "QC Manual",
      "IFC Drawings/QC Manual ",
      "IFC Drawing ,Surface Prep and Coating Procedure ",
      "SHOP Spec. SPC-PD-PRO-003",
      "ISO Spool drawings, Line List",
    ],
    "Res. Party/ Location": ["SHOP", "TBD", "Sub-contract"],
    "ACCEPTANCE CRITERIA": [
      "ASME B31.3/Specification",
      "ASME IX/ ASME B31.3",
      "ASME IX/ASME B31.3",
      "ASME B31.3",
      "QC Manual",
      "ASME B31.3",
      "Surface Prep and Coating Specification",
      "PO",
      "CSA B51",
    ],
    "RECORDING DOCUMENT": [
      "ITP Initials",
      "ITP Initials/ Welders Log",
      "Declaration Letter",
      "ITP/MTR Initials",
      "ITP Initials/Travel Sheet ",
      "ITP Initials, PWHT report",
      "ITP Initials/ NDE Reports",
      "ITP Initials, Hydrotest Report",
      "U Form",
      "ITP Initials/Travel Sheet ",
    ],
    shopType: ["H", "W", "R", "V"],
    clientType: ["H", "W", "R", "V"],
  },
  "Assembly and Testing": {
    "INSPECTION/TEST ACTIVITY": [
      "Verification of Instrument tagging and component identification",
      "Verify overall dimensions",
      "P & ID check/ walkdown",
      "Pneumatic Testing, as applicable",
      "Functional Test ( Valve Stroking, Electrical Continuity)",
    ],
    "CONTROLLING DOCUMENT": [
      "Approved Drawings & Procedures",
      "Approved Drawings",
      "IFC/ Data Sheets/ PO/ SOW",
    ],
    "Res. Party/ Location": ["SHOP", "TBD", "Sub-contract"],
    "ACCEPTANCE CRITERIA": [
      "ASME B31.3/ P & ID",
      "Approved Drawings & Procedures",
    ],
    "RECORDING DOCUMENT": [
      "ITP Initials",
      "ITP Initials/ Welders Log",
      "Declaration Letter",
      "ITP/MTR Initials",
      "ITP Initials/Travel Sheet ",
      "ITP Initials, PWHT report",
      "ITP Initials/ NDE Reports",
      "ITP Initials, Hydrotest Report",
      "U Form",
      "ITP Initials/Travel Sheet ",
    ],
    shopType: ["H", "W", "R", "V"],
    clientType: ["H", "W", "R", "V"],
  },
  "Preparation for Shipment": {
    "INSPECTION/TEST ACTIVITY": [
      "Package Final Cleanliness",
      "Packing List",
      "Deficiencies (Punch) List & NCR Closeout",
      "Mud book review and approval, as applicable",
      "Final Inspection - Paint, insulation and Isometric drawing walkdown for supports, guides, anchors & vessel regestration ",
      "Shipping Release",
      "Quality Data Books Complete and Signed Off",
    ],
    "CONTROLLING DOCUMENT": ["Approved Drawings & Procedures", "PO/SOW"],
    "Res. Party/ Location": ["SHOP", "TBD", "Sub-contract"],
    "ACCEPTANCE CRITERIA": ["Approved Drawings & Procedures", "PO/SOW"],
    "RECORDING DOCUMENT": [
      "ITP Initials",
      "Packing List",
      "Punch List",
      "Shipping Release",
    ],
    shopType: ["H", "W", "R", "V"],
    clientType: ["H", "W", "R", "V"],
  },
};
